<template>
  <right-menu-item
    v-if="showPublishDocumentBtn"
    @click.prevent="clickPublishDocument"
    :class="{'!text-green-600': !loading && isActivePublishDocumentBtn, 'muted': loading || !isActivePublishDocumentBtn}"
    :text="$t('Publish changes')"
    loading-text="Saving..."
    :loading="loading"
    icon="eye-opened"
  />
</template>

<script>
import PublishDocumenButton from '../../mixins/PublishDocumentButton'

export default {
  mixins: [PublishDocumenButton],
}
</script>

<style lang="scss" scoped></style>
